export default __webpack_public_path__ + "static/media/rticc-logo.e717faae.png";